import { terminal } from 'virtual:terminal';

import {
  ELogLevels,
  ELogIcons,
  type ILogger,
  type TLoggerProps,
} from '@client/types/logger.type';

const monitor = (props: TLoggerProps) => {
  const { type = ELogLevels.INFO, args = [], echo = console } = props;

  // Normalize type to lowercase
  const level = type.toLowerCase() as Lowercase<ELogLevels>;

  // Validate log level
  if (
    !Object.values(ELogLevels)
      .map((l: ELogLevels) => l.toLowerCase())
      .includes(level)
  ) {
    throw new Error(
      `Invalid log type: ${type}. Must be one of ${Object.values(ELogLevels).join(', ')}.`,
    );
  }

  // Get icon based on a lowercase key
  const icon = ELogIcons[level as keyof typeof ELogIcons];

  // Log with fallback
  (echo[level] || echo.log)(icon, ...args);
  (terminal[level] || terminal.log)(...args);
};

export const logger: ILogger = {
  debug: (message, ...meta) =>
    monitor({ type: ELogLevels.DEBUG, args: [message, ...meta] }),
  log: (message, ...meta) =>
    monitor({ type: ELogLevels.LOG, args: [message, ...meta] }),
  info: (message, ...meta) =>
    monitor({ type: ELogLevels.INFO, args: [message, ...meta] }),
  warn: (message, ...meta) =>
    monitor({ type: ELogLevels.WARN, args: [message, ...meta] }),
  error: (message, ...meta) =>
    monitor({ type: ELogLevels.ERROR, args: [message, ...meta] }),
};
